import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useContext } from 'react';
import { ModalContext } from './ModalContext.js';

var _templateObject;
var StyledContent = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-height: ", ";\n  overflow: auto;\n  margin: 1.875rem 0;\n  text-align: left;\n"])), function (_ref) {
  var _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '2000px' : _ref$maxHeight;
  return maxHeight;
});
var ModalContent = function ModalContent(_ref2) {
  var children = _ref2.children;
  var _useContext = useContext(ModalContext),
    contentMaxHeight = _useContext.contentMaxHeight;
  return /*#__PURE__*/React.createElement(StyledContent, {
    maxHeight: contentMaxHeight,
    role: 'dialog',
    tabIndex: 0
  }, children);
};
var ModalContent$1 = /*#__PURE__*/memo(ModalContent);

export default ModalContent$1;
export { ModalContent };
